import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
};
const _hoisted_2 = {
  key: 1,
  class: "bg-white rounded-xl border border-slate-200 py-20"
};
const _hoisted_3 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
};
const _hoisted_4 = {
  class: "p-5"
};
const _hoisted_5 = {
  class: "flex items-start gap-4"
};
const _hoisted_6 = {
  class: "shrink-0"
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
  key: 1,
  class: "w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center"
};
const _hoisted_9 = {
  class: "flex-1 min-w-0"
};
const _hoisted_10 = {
  class: "flex items-center gap-2 mb-1"
};
const _hoisted_11 = {
  class: "text-sm font-semibold text-slate-900 truncate"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  class: "flex items-center gap-0.5 shrink-0"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "mt-3 flex items-center gap-1.5 text-xs text-slate-400"
};
const _hoisted_17 = {
  class: "px-5 py-3 border-t border-slate-100 bg-slate-50/50 rounded-b-xl"
};
const _hoisted_18 = ["onClick"];
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getKfAccounts, deleteKfAccount } from '@/api/weworkKf';
import ListPageShell from '@/components/ListPageShell.vue';
import KfAccountFormModal from './components/KfAccountFormModal.vue';
import KfServicerModal from './components/KfServicerModal.vue';

// 数据

export default {
  __name: 'WeworkKfManagement',
  setup(__props) {
    const loading = ref(false);
    const accountList = ref([]);

    // 表单弹窗状态
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const editAccountData = ref(null);
    const formModalRef = ref();

    // 接待人员弹窗状态
    const showServicerModal = ref(false);
    const currentAccount = ref(null);

    // 状态配置
    const statusConfig = {
      1: {
        label: '启用',
        dot: 'bg-emerald-400',
        text: 'text-emerald-700',
        bg: 'bg-emerald-50'
      },
      0: {
        label: '禁用',
        dot: 'bg-slate-400',
        text: 'text-slate-600',
        bg: 'bg-slate-100'
      }
    };

    // 获取数据
    async function fetchData() {
      loading.value = true;
      try {
        const data = await getKfAccounts();
        accountList.value = data || [];
      } catch (error) {
        ElMessage.error('加载客服账号列表失败');
      } finally {
        loading.value = false;
      }
    }

    // 新增
    const handleAdd = () => {
      isEdit.value = false;
      editAccountData.value = null;
      showFormModal.value = true;
    };

    // 编辑
    const handleEdit = item => {
      isEdit.value = true;
      editAccountData.value = {
        ...item
      };
      showFormModal.value = true;
    };

    // 表单提交成功回调
    const handleFormSuccess = () => {
      formModalRef.value?.done();
      fetchData();
    };

    // 表单提交失败回调
    const handleFormError = () => {
      formModalRef.value?.done();
    };

    // 删除
    const handleDelete = async item => {
      try {
        await ElMessageBox.confirm(`确定要删除客服账号「${item.name}」吗？删除后无法恢复。`, '确认删除', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteKfAccount(item.id);
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败');
        }
      }
    };

    // 管理接待人员
    const handleManageServicers = item => {
      currentAccount.value = item;
      showServicerModal.value = true;
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "text-xl font-semibold text-slate-900"
        }, "微信客服管理"), _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-1"
        }, "管理企业微信客服账号及接待人员")], -1)), _createElementVNode("div", {
          class: "list-page-heading-actions"
        }, [_createElementVNode("button", {
          onClick: handleAdd,
          class: "btn-primary inline-flex items-center gap-2"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新增客服账号 ", -1)]))])])])])]),
        default: _withCtx(() => [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, n => {
          return _createElementVNode("div", {
            key: n,
            class: "bg-white rounded-xl border border-slate-200 p-5 animate-pulse"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
            class: "flex items-center gap-4 mb-4"
          }, [_createElementVNode("div", {
            class: "w-12 h-12 bg-slate-200 rounded-full shrink-0"
          }), _createElementVNode("div", {
            class: "flex-1"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-24 mb-2"
          }), _createElementVNode("div", {
            class: "h-3 bg-slate-200 rounded w-40"
          })])], -1), _createElementVNode("div", {
            class: "h-3 bg-slate-200 rounded w-32 mb-3"
          }, null, -1), _createElementVNode("div", {
            class: "h-8 bg-slate-200 rounded w-full"
          }, null, -1)]))]);
        }), 64))])) : accountList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "w-8 h-8 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        })])]), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无客服账号"), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "点击上方按钮创建第一个客服账号")], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "bg-white rounded-xl border border-slate-200 hover:shadow-md transition-shadow"
          }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [item.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.avatar,
            alt: item.name,
            class: "w-12 h-12 rounded-full object-cover border-2 border-slate-100"
          }, null, 8, _hoisted_7)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
            class: "w-6 h-6 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          })], -1)]))]))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h3", _hoisted_11, _toDisplayString(item.name), 1), _createElementVNode("span", {
            class: _normalizeClass([[statusConfig[item.status]?.bg, statusConfig[item.status]?.text], "status-badge shrink-0"])
          }, [_createElementVNode("span", {
            class: _normalizeClass([statusConfig[item.status]?.dot, "w-1.5 h-1.5 rounded-full"])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusConfig[item.status]?.label || '未知'), 1)], 2)]), _createElementVNode("p", {
            class: "text-xs text-slate-400 truncate",
            title: item.openKfid
          }, " ID: " + _toDisplayString(item.openKfid || '-'), 9, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
            onClick: $event => handleEdit(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_14), _createElementVNode("button", {
            onClick: $event => handleDelete(item),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_15)])]), _createElementVNode("div", _hoisted_16, [_cache[9] || (_cache[9] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(formatTime(item.createTime)), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("button", {
            onClick: $event => handleManageServicers(item),
            class: "btn-outline-primary w-full inline-flex items-center justify-center gap-2"
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          })], -1), _createTextVNode(" 管理接待人员 ", -1)]))], 8, _hoisted_18)])]);
        }), 128))])), _createVNode(KfAccountFormModal, {
          ref_key: "formModalRef",
          ref: formModalRef,
          show: showFormModal.value,
          "onUpdate:show": _cache[0] || (_cache[0] = $event => showFormModal.value = $event),
          "is-edit": isEdit.value,
          "account-data": editAccountData.value,
          onSuccess: handleFormSuccess,
          onError: handleFormError
        }, null, 8, ["show", "is-edit", "account-data"]), _createVNode(KfServicerModal, {
          show: showServicerModal.value,
          "onUpdate:show": _cache[1] || (_cache[1] = $event => showServicerModal.value = $event),
          account: currentAccount.value
        }, null, 8, ["show", "account"])]),
        _: 1
      });
    };
  }
};